import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const BusinessEmailVerify = () => {
  const navigate = useNavigate();
  const token = new URLSearchParams(window.location.search).get('token');
  const [isVerifying, setIsVerifying] = useState(false);

  useEffect(() => {
    if (isVerifying) return;
    setIsVerifying(true);

    const clientEmailVerify = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/verify-business-email?token=${token}`,
          { withCredentials: true }
        );
        alert('Email verified successfully!');
        navigate('/login');
      } catch (error) {
        console.error('Verification failed:', error);
        alert('Failed to verify email.');
      }
    };

    if (token) {
      clientEmailVerify();
    }
  }, [token, navigate, isVerifying]);

  return <div>Verifying your email...</div>;
};

export default BusinessEmailVerify;
